import { Drawer, DrawerHeaderProps } from '@chronosphereio/chrono-ui';
import React from 'react';

interface VizPanelInspectorProps extends Pick<DrawerHeaderProps, 'badge'> {
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
}

export function VizPanelInspector({ isOpen, onClose, badge, children }: VizPanelInspectorProps) {
  return (
    <Drawer open={isOpen} onClose={onClose} size="large" data-testid="panel-inspector">
      <Drawer.Header title="Inspect panel" onSecondaryButtonClick={onClose} badge={badge} />
      <Drawer.Content>{children}</Drawer.Content>
    </Drawer>
  );
}
